<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-dim on">
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner center">
          <div class="modal">
            <div class="modal-head">
              <h1>앱 푸시 동의 안내</h1>
            </div>
            <div class="modal-con">
              <div class="author-box">
                <div class="con">
                  <div class="row">
                    <p>전송자</p>
                    <h6>예소스교육연구소</h6>
                  </div>
                  <div class="row">
                    <p>수신 동의 일시</p>
                    <h6>{{ dayjs().format('YYYY년 MM월 DD일 HH시') }}</h6>
                  </div>
                  <div class="row">
                    <p>처리 내용</p>
                    <h6 v-if="state.isPush === 'SEND'">수신 동의 처리 완료</h6>
                    <h6 v-else>수신 동의 처리 거부</h6>
                  </div>
                </div>
              </div>
              <div class="modal-txt mt20">
                <p>
                  본 광고성 알림(PUSH)는<br />
                  환경 설정에서 변경 가능합니다.
                </p>
              </div>
            </div>
            <div class="modal-btn">
              <div class="btn-wrap">
                <button class="btn" @click="$emit('close')">확인</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PUSH_CONFIRM'
};
</script>
<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';
import { useStore } from 'vuex';
const { getters } = useStore();
const state = computed(() => getters['user/getUserData']);
</script>
